module.exports = __webpack_public_path__ + "static/img/h6-2.0422fca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h6-2.png
// module id = KK9z
// module chunks = 1